// Create a Providers component to wrap your application with all the components requiring 'use client', such as next-nprogress-bar or your different contexts...
'use client'

// @ts-ignore
import { ProgressProvider } from '@bprogress/next/app'
import React from 'react'

export const ProgressBarProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <ProgressProvider
      height='4px'
      color='var(--ds-color-base-main)'
      options={{ showSpinner: false }}
      shallowRouting
    >
      {children}
    </ProgressProvider>
  )
}
